import { InsurancePolicy } from '@/types/insurancePolicy';
import { Staff, PersonSimple } from '@/types/person';

import { ExternalPolicyVerification, ExternalVerificationState } from './externalVerification';

export enum InsuranceVerificationStatus {
  VERIFIED = 'Verified',
  FAILED = 'Failed Verification',
  PENDING = 'Pending Verification',
  BILLING_REQUIREMENTS_MET = 'Billing Requirements Met',
  PENDING_COB = 'Pending Coordination of Benefits'
}

export interface InsuranceVerification {
  id?: string;
  insurance_policy_id?: string; // write_only
  status: InsuranceVerificationStatus;
  verified_at?: string;
  verified_by?: Staff;
  verified_via?: InsuranceVerificationSource | string | null;
  verified_through?: string;
  vob_notes?: string | null;
  deductible_remaining?: number | null; // amount in cents
  out_of_pocket_maximum_remaining_in_cents?: number | null;
  estimated_monthly_cost_in_cents?: number | null;
  estimated_initial_month_cost_in_cents?: number | null;
  external_policy_verification?: ExternalPolicyVerification | null;
  service_code?: string | null;
  used_policyholder_info?: boolean;
}

export interface InsuranceVerificationListItem extends InsuranceVerification {
  insurance_policy?: InsurancePolicyWithMember;
  days_since_verified?: number | null;
  member_id?: string;
  member_first_name?: string;
  member_last_name?: string;
  member_birthday?: string;
  member_jurisdiction?: string;
  member_status?: string;
  policy_carrier?: string;
  policy_plan?: string;
  policy_subscriber_id?: string;
  policy_member_id?: string | null;
  policy_group_id?: string | null;
  policy_type?: string | null;
  policy_verification_status?: string | null;
  policy_priority_type?: string;
  policy_provider_name?: string;
  policy_created_at?: string;
  policy_start_date?: string | null;
  policy_end_date?: string | null;
  policy_deleted_at?: string | null;
  external_verification_state?: ExternalVerificationState | null;
}

export interface InsurancePolicyWithMember extends InsurancePolicy {
  member?: PersonSimple;
}

export interface InsuranceVerificationSource {
  id: string;
  name: string;
}
